import { Flex } from 'antd'

import { isImageMime } from './attachments'
import type { ChatAttachment } from './attachments'
import { ChatAttachmentCard } from './ChatAttachmentCard'
import { ChatAttachmentThumbnail } from './ChatAttachmentThumbnail'
import { useAttachmentActions } from './useAttachmentActions'
import type { ResolveAttachmentUrl } from './useAttachmentActions'

type Props = {
  attachments: ChatAttachment[]
  resolveUrl?: ResolveAttachmentUrl
}

export const ChatAttachmentList = ({ attachments, resolveUrl }: Props) => {
  const { busyId, open } = useAttachmentActions(resolveUrl)

  return (
    <Flex wrap gap="small" align="flex-start">
      {attachments.map((attachment) =>
        isImageMime(attachment.mimeType) && attachment.url ? (
          <ChatAttachmentThumbnail
            key={attachment.id}
            attachment={attachment}
            busy={busyId === attachment.id}
            onOpen={() => open(attachment)}
            resolveUrl={resolveUrl}
          />
        ) : (
          <ChatAttachmentCard
            key={attachment.id}
            attachment={attachment}
            busy={busyId === attachment.id}
            onOpen={() => open(attachment)}
          />
        )
      )}
    </Flex>
  )
}
